import React from 'react';
import { connect } from 'react-redux';
import './signin.scss';
import {
  FormField,
  Input,
  InputLabel,
  SectionBody, SectionHeader,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import warning from '../../static/images/mvp/warning.png';
import { CustomSelectComponent, formTheme } from './ThemeSignIn';
import { I18n } from '../../helpers/i18n';

class SignUpSeniorInfo extends React.Component {
  constructor(props) {
    super(props);
    this.inputs = {};
    this.state = {};

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
    this.props.onInputChange(evt);
  }

  handleSelectHealthStatus = (event) => {
    this.props.onSelectHealthStatus(event.target.value);
  };

  render() {
    const {
      errorEmail,
      errorName,
      errorPassword,
      errorRePassword,
      errorNote,
      errorRelativeName,
      errorGiftCode,
      errorRelativeEmail,
      healthStatusList,
      healthStatus
    } = this.props;
    const theme = {
      color: '#000000',
      fontSize: '16px',
      lineHeight: '24px',
      borderColor: '#CCCCCC',
      borderRadius: '4px',
      padding: '14px 16px',
    };

    return (
      <SectionBody theme={formTheme}>
        <SectionHeader theme={formTheme}
                       style={{ marginBottom: '16px' }}>{I18n.t('register_health_info_senior_info_section_title')}</SectionHeader>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('senior_account_account_info_email_label')} <span className="text-danger">*</span></InputLabel>
          <Input
            autoFocus
            placeholder={I18n.t('email_hint_text')}
            key="email"
            name="email"
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorEmail ? '#FF445D' : '#cccccc' } }}
          />
          {errorEmail && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorEmail}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('name_hint_text')} <span className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('name_hint_text')}
            key="name"
            name="name"
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorName ? '#FF445D' : '#cccccc' } }}
          />
          {errorName && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorName}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('password')} <span
            className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('password_hint')}
            key="password"
            name="password"
            type="password"
            onChange={this.handleInputChange}
            theme={{ input: { ...theme, borderColor: errorPassword ? '#FF445D' : '#cccccc' } }}
            autoComplete="off"
          />
          {errorPassword && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorPassword}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('password_hint')} <span
            className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('password_hint')}
            key="rePassword"
            name="rePassword"
            type="password"
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorRePassword ? '#FF445D' : '#cccccc' } }}
          />
          {errorRePassword && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorRePassword}
                  </span>
          )}
        </FormField>
        <CustomSelectComponent
          title={I18n.t('health_status')}
          required={true}
          options={healthStatusList}
          selectedValue={healthStatus}
          onChange={this.handleSelectHealthStatus}
        ></CustomSelectComponent>
        <FormField theme={formTheme}>
          <InputLabel style={{marginTop: '16px'}} theme={formTheme}>{I18n.t('register_health_note_hint_text')}
          </InputLabel>
          <Input
            placeholder={I18n.t('register_input_health_note_hint_text')}
            key="healthNote"
            name="healthNote"
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorNote ? '#FF445D' : '#cccccc' } }}
          />
          {errorNote && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorNote}
                  </span>
          )}
        </FormField>
        <SectionHeader theme={formTheme}
                       style={{ marginBottom: '16px' }}>{I18n.t('register_health_info_family_section_title')}</SectionHeader>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('senior_account_account_info_fullname_family_member_hint_text')} <span
            className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('senior_account_account_info_fullname_family_member_hint_text')}
            key="relativeName"
            name="relativeName"
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorRelativeName ? '#FF445D' : '#cccccc' } }}
          />
          {errorRelativeName && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorRelativeName}
                  </span>
          )}
        </FormField>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('register_health_info_family_email_hint_text')} <span
            className="text-danger">*</span></InputLabel>
          <Input
            placeholder={I18n.t('senior_account_account_info_email_label_hint_text')}
            key="relativeEmail"
            name="relativeEmail"
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorRelativeEmail ? '#FF445D' : '#cccccc' } }}
          />
          {errorRelativeEmail && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorRelativeEmail}
                  </span>
          )}
        </FormField>
        <SectionHeader theme={formTheme}
                       style={{ marginBottom: '16px' }}>{I18n.t('gift_code')}</SectionHeader>
        <FormField theme={formTheme}>
          <InputLabel theme={formTheme}>{I18n.t('gift_code')} </InputLabel>
          <Input
            placeholder={I18n.t('gift_code')}
            key="giftCode"
            name="giftCode"
            onChange={this.handleInputChange}
            autoComplete="off"
            theme={{ input: { ...theme, borderColor: errorGiftCode ? '#FF445D' : '#cccccc' } }}
          />
          {errorGiftCode && (
            <span className="error-message">
                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
              {errorGiftCode}
                  </span>
          )}
        </FormField>
      </SectionBody>
    );
  };
}

const mapStateToProps = ({ user }) => ({
  userInfo: user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpSeniorInfo);
